<template>
  <div class="dashboard-container">
    <!-- 顶部汇总 -->
    <PlanTop :PlanStatistic="PlanStatistic"></PlanTop>
    <!-- 查询条件区域 -->
    <planSearchForm ref="planSearchForm" @handleSearch="handleSearch"></planSearchForm>
    <!-- 主内容区域 -->
    <div class="main-content" v-loading="loadingContent">
      <!-- 左侧计划列表 -->
      <PlanListContainer v-model="planId" @selectPlan="selectPlan" class="plan-list-container"></PlanListContainer>
      <PlanCarsContainer class="car-list-container"></PlanCarsContainer>
      <!-- 右侧计划详情 -->
      <PlanDetailContainer v-loading="loadingDetail" class="plan-detail-container"></PlanDetailContainer>
    </div>
  </div>
</template>

<script>
import PlanListContainer from "./components/plan-list-container";
import PlanDetailContainer from "./components/plan-detail-container";
import PlanSearchForm from "./components/plan-search-form";
import PlanCarsContainer from "./components/plan-cars-container";
import PlanTop from "./components/plan-top";
import { dailyPlanStatistics, dailyPlanPage, planDetail, getPlanTimeline,getPlanCars } from "./api";

export default {
  components: {
    PlanListContainer,
    PlanDetailContainer,
    PlanSearchForm,
    PlanTop,
    PlanCarsContainer
  },
  provide () {
    return {
      _parentThis: this,
    }
  },
  data () {
    return {
      time: '',
      planStatistic: {},
      loadingContent: false,
      loadingDetail: false,
      planList: [],
      detailData: {},
      planTimelineList: [],
      planId: '',
      planCarsList: []
    };
  },
  mounted () {
    this.initData()
    this.time = setInterval(() => {
      this.initData()
    }, 60000);
  },
  deactivated () {
    clearInterval(this.time);
    this.timer = '';
  },
  methods: {
    initData () {
      // 汇总
      dailyPlanStatistics().then(({ data }) => {
        this.planStatistic = data.data
      })
      //列表
      this.getDailyPlanPage()
    },
    //列表
    getDailyPlanPage () {
      const { searchForm } = this.$refs.planSearchForm
      dailyPlanPage(searchForm).then(({ data: { data } }) => {
        if (!data.records.length) {
          this.detailData = {}
          this.planList = []
          this.planCarsList = []
          this.planId = ''
          this.planTimelineList = []
        } else {
          this.planList = data.records
          this.planId = this.planId || this.planList[0].id
        }
      }).finally(() => {
        this.loadingContent = false
      })
    },
    // 详情
    getPlanDetail (id,trainNumber) {
      planDetail(id,trainNumber).then(({ data: { data } }) => {
        this.detailData = data
      }).finally(() => {
        this.loadingDetail = false
      })
    },
    // 详情时间轴
    getPlanTimeline (id,businessType,trainNumber) {
      //   this.loadingDetail = true
      getPlanTimeline(id,businessType).then(({ data: { data } }) => {
        this.planTimelineList = data
      })
      this.loadingDetail = true
      this.getPlanDetail(id,trainNumber)
    },
    getPlanCars (id) {
      getPlanCars(id).then(({ data: { data } }) => {
        this.planCarsList = data
      })
    },
    // 列表--> 详情数据刷新
    selectPlan ({ id }) {
      this.planTimelineList = []
      this.detailData = {}
      this.getPlanCars(id)
      // this.getPlanTimeline(id)
    },
    // 查询回调
    handleSearch () {
      this.loadingContent = true
      this.getDailyPlanPage()
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.dashboard-container {
  font-family: "HarmonyOS Sans", "PingFang SC", "Arial", sans-serif;
  color: #1f2b4d;
  background: #edf2fa;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(31, 82, 255, 0.2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* 主内容区域 */
  .main-content {
    margin-top: 12px;
    flex: 1;
    display: grid;
    grid-template-columns: 20% 15% 1fr;
    gap: 5px;
    min-height: 0;

    .plan-list-container,
    .car-list-container,
    .plan-detail-container {
      min-height: 0;
    }

    .plan-list-container,
    .car-list-container {
      overflow: auto;
    }

    .plan-detail-container {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      margin-left: 10px;
    }
  }
}
</style>
